import React, { Component } from 'react';
import ObjectsList from './objects-list.component';
import Search from './search.component';
import Map from './map.component';
import '../styles/full-layout.css';
import { AppContext } from '../context';
import { ObjectType } from '../types/object.type';
import TranslationService from '../services/translation.service';

class FullLayout extends Component<{isMobile: boolean, isTablet: boolean}> {
  static contextType = AppContext;
  context!: React.ContextType<typeof AppContext>;
  state: any;
  constructor (props: any) {
    super(props);
    this.state = {
      mapOpen: true
    };
  }

  unhideObjects () {
    const { state, dispatch } = this.context;
    const results = (state.results && state.results.nb > 0 ? state.results.results : false);
    if (! results || results.length === 0) {
      return;
    }
    const objects = results.map((object: ObjectType) => {
      object.hidden = false;
      return object;
    });
    dispatch({
      type: "setResults",
      payload: {
        results: {
          nb: objects.length,
          results: objects
        }
      }
    });
  }

  render () {
    return (
      <div id='search-full-layout' className={this.props.isMobile ? 'mobile' : (this.props.isTablet ? 'tablet' : 'desktop')}>
        <div className='layout-search-container'>
          <img src="https://www.luxury-places.ch/themes/custom/luxuryplaces/img/background_lp_search.webp" alt="background" />
          <Search isMobile={this.props.isMobile} isTablet={this.props.isTablet} />
        </div>
        <div className={'layout-results' + (this.state.mapOpen ? '' : ' map-close')}>
          <div className='object-list-wrapper'>
            <ObjectsList/>
          </div>
          <div className={'map-btn ' + (this.state.mapOpen ? 'close' : 'open')} onClick={() => {
            this.setState({
              mapOpen: !this.state.mapOpen
            });
            if (this.state.mapOpen) {
              this.unhideObjects();
            }
          }}>
            <span className='icon'>
              {this.state.mapOpen ?
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="20" viewBox="18 15 10 20">
                  <path d="M20.388 24.909 28 33.523 26.928 35 18 24.953 26.684 15 28 16.338l-7.612 8.571Z" fill="rgba(98, 98, 98, 1)" fillRule="evenodd" data-name="Icon"/>
                </svg>
                :
                <img
                  alt={TranslationService.getMessage('Map', this.context.state.language)}
                  src="https://www.luxury-places.ch/themes/custom/luxuryplaces/img/icons/map.svg" />
              }
            </span>
          </div>
          <div className='map-wrapper'>
            <Map
              height={(this.props.isMobile ? '640px' : false)}
              stopHide={!this.state.mapOpen}
              isMobile={this.props.isMobile}
              isTablet={this.props.isTablet} />
          </div>
        </div>
      </div>
    );
  }
}
export default FullLayout;
